export enum EFilters {
  ALL = 'All',
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  LAST_WEEK = 'Week',
  LAST_MONTH = 'Month'
}
